import { FC } from 'react';

import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';

import styles from './Jackpot.module.css';

export const Jackpot: FC = () => {
  const isAnimationToggle = useHighflyerGameStateSlice.getAnimationToggle();

  if (!isAnimationToggle) return null;

  return (
    <>
      <div className={`${styles.jackpotContainer}`}>
        <div className={`${styles.pyro}`}>
          <div className={`${styles.before}`}></div>
          <div className={`${styles.after}`}></div>
        </div>

        <div className={`${styles.firework}`}></div>
        <div className={`${styles.firework} ${styles.firework2}`}></div>
        <div className={`${styles.firework} ${styles.firework3}`}></div>

        <div className={`${styles.firework}`}></div>
        <div className={`${styles.firework}`}></div>
        <div className={`${styles.firework}`}></div>
      </div>
    </>
  );
};
